import AOS from 'aos';
import 'aos/dist/aos.css';
import React, { useEffect } from 'react';
import { Carousel } from "../components/common/Carousel";
import FloatingWhatsapp from '../components/whatsapp/FloatingWhatsapp';
import { About } from "./About";
import { Blog } from "./Blog";
import { Courses } from "./Courses";
import { Instructor } from "./Instructor";


export const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: false,
      offset: 50,
    });
  }, []);
  return (
    <>
      <Carousel id="inicio"/>
      <About/>
      <Courses/>
      <Instructor/>
      <Blog />
      <FloatingWhatsapp
        phone="51967575397"
        message="WhatsApp - Chatear Ahora!"
        size="70px"
        backgroundColor="#25D366"
        popupMessage="Bienvenido a Cevatur Piura, ¿En qué puedo ayudarte?"
        showPopup={true}
        buttonImage="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
      />
    </>
  )
}
